// Die Saetze des Stichwort-Suchfelds, ohne React, damit sie sich ohne Browser
// pruefen lassen.

import { MAXIMUM_TERM_QUERY_LENGTH } from "./aufloesung.ts";

/** Bis hierhin bleibt die Auswahl ein Select (DESIGN). */
export const SELECT_HOECHSTENS = 20;

/** Was die Region bei offener Liste sagt (DESIGN P2-2): Zahl oder Grenze vorne, dann die Vormerkung. */
export function listenSatz(stand: {
  readonly getippt: string;
  readonly anzahl: number;
  readonly hinweis: string | undefined;
  readonly vorgemerkt: string | undefined;
}): string {
  const tab = stand.vorgemerkt === undefined ? "" : ` Tab übernimmt „${stand.vorgemerkt}“.`;
  if (stand.anzahl === 0) return stand.hinweis ?? "";
  if (stand.getippt.trim() === "") {
    return stand.hinweis === undefined ? `${stand.anzahl} Stichworte.${tab}` : `${stand.anzahl} Stichworte; tippe, um weitere zu finden.${tab}`;
  }
  const vorne = stand.hinweis ?? `${stand.anzahl} Treffer.`;
  return `${vorne}${tab}`;
}

/** Der Satz unter der Liste; undefined, wenn nichts zu sagen ist. */
export function listenHinweis(stand: {
  readonly getippt: string;
  readonly anzahl: number;
  /** Wie viele Begriffe die Quelle geliefert hat, vor dem Abzug der gewaehlten. */
  readonly geliefert: number;
  readonly gekuerzt: boolean;
  readonly ersteSeiteMehr: boolean;
  readonly gestoert: boolean;
}): string | undefined {
  if (stand.gestoert)
    return "Die Stichworte lassen sich gerade nicht suchen. Versuche es gleich noch einmal.";
  if (stand.getippt.trim() === "")
    return stand.ersteSeiteMehr ? "Tippe, um weitere zu finden." : undefined;
  if (stand.getippt.length >= MAXIMUM_TERM_QUERY_LENGTH)
    return `Ein Stichwort hat höchstens ${MAXIMUM_TERM_QUERY_LENGTH} Zeichen.`;
  // „gekuerzt“ heisst nur unvollstaendig (auch eine abgeschnittene
  // Nachfolgerkette); eine Zahl nennt der Satz nur, wenn sie geliefert ist.
  if (stand.gekuerzt)
    return stand.geliefert >= SELECT_HOECHSTENS
      ? `Mindestens ${SELECT_HOECHSTENS} Treffer – tippe weiter, um einzugrenzen.`
      : stand.geliefert === 0
        ? "Die Suche ist zu breit – tippe weiter, um einzugrenzen."
        : "Nicht alle Treffer lassen sich zeigen – tippe weiter, um einzugrenzen.";
  if (stand.anzahl === 0)
    return `Kein Stichwort passt zu „${stand.getippt.trim()}“.`;
  return undefined;
}
